// contractWidgetCodes.js — 회사별·통합 계약 위젯 번호 읽기 (2026-10-19)
//   사용자: "계약 관리 위젯 같이 그대로 만들어 줘"(통합 + 회사별도 같이).
//   본사 '계약 관리' 위젯 3개(마케터별 계약·상담자별 계약·최근 계약)와 같은 모양을 쓰고, 숫자 받는 주소만 바꾼다.
//     통합:  admin_integrated_{메뉴번호}_{marketer|consultant|recent} → /api/admin/integrated-menus/{번호}/contracts
//     회사별: admin_contract_{marketer|consultant|recent}_{회사코드 소문자} → /api/admin/ext/{회사코드}/contracts
//   서버 짝: api/services/integrated-menu-widgets.js · situation-widget-registry.admin-contract.js.
//   볼 수 있는 사람은 서버가 정한다(/my/situation-widgets) — 여기는 번호를 읽어 주소를 만들 뿐이다.

export const CONTRACT_WIDGET_PARTS = ['marketer', 'consultant', 'recent'];

const PART_RE = CONTRACT_WIDGET_PARTS.join('|');
const INTEGRATED_RE = new RegExp(`^admin_integrated_([0-9]+)_(${PART_RE})$`);
const COMPANY_RE = new RegExp(`^admin_contract_(${PART_RE})_([a-z0-9]+)$`);

/**
 * 위젯 번호 → { part, kind:'integrated', menuId, base } | { part, kind:'company', companyCode, base } | null
 *   base = 그 화면 계약 주소(목록). 월별은 `${base}/by-month`.
 */
export function parseContractWidgetCode(code) {
  const text = String(code || '');
  let m = INTEGRATED_RE.exec(text);
  if (m) {
    const menuId = Number(m[1]);
    return { part: m[2], kind: 'integrated', menuId, base: `/api/admin/integrated-menus/${menuId}/contracts` };
  }
  m = COMPANY_RE.exec(text);
  if (m) {
    const companyCode = m[2].toUpperCase();
    return { part: m[1], kind: 'company', companyCode, base: `/api/admin/ext/${companyCode}/contracts` };
  }
  return null;
}

export function isContractWidgetCode(code) {
  return parseContractWidgetCode(code) !== null;
}
